/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DateFormats {
    ShortDate = 1,
    LongDate = 2,
    LongDateShortMonth = 12,
    Time = 5,
    TimeWithKl = 15,
    TimeWithSeconds = 11,
    ShortDateAndTimeWithKl = 14,
    ShortDateAndTime = 6,
    ShortDateAndTimeIfProvided = 7,
    LongDateAndTime = 8,
    LongDateAndTimeIfProvided = 9,
    ShortDateAndTimeWithSeconds = 10,
    ShortDateAndTimeWithSecondsIfProvided = 13,
}
